module.exports = __webpack_public_path__ + "img/flower.095ae97c.webp";